<div class="flex flex-col h-100-percent service-def-header">
  <div class="max-width-lg header" [ngClass]="{ 'pb-26': showQuestionnaireSection }">
    <app-breadcrumb [items]="breadcrumbItems" class="mt-16 pl-20"></app-breadcrumb>
    <div class="flex flex-row">
      <mat-icon svgIcon="arrow_back" class="icon-md-1 cursor-pointer ml-10" (click)="goBack()"></mat-icon>
      <div class="flex flex-col ml-30">
        <div class="mat-headline-5 mb-4" *ngIf="!blueprintId">{{sandbox ? ('SERVICE.CREATE_SANDBOX' | transloco) : ('SERVICE.CREATE_SERVICE_DEFINITION' | transloco) }}</div>
        <div class="mat-headline-5 mb-4" *ngIf="blueprintId">{{ sandbox ? ('SERVICE.UPDATE_SANDBOX' | transloco) : ('SERVICE.UPDATE_SERVICE' | transloco) }}</div>
        <div class="mat-body-2 fw-400">{{ service?.name }}</div>
      </div>
    </div>
    <div *ngIf="!showQuestionnaireSection" class="max-width-lg bg-gradient pt-54">
      <div class="flex flex-col">
        <div class="flex flex-row">
          <div class="flex tab-overview tab active pt-16 pr-16 pb-20 pl-16" [ngClass]="{ 'active': selectedTab === TabId.SETUP }" (click)="selectedTab = TabId.SETUP">
            <button class="btn-link" [ngClass]="{ 'active': selectedTab === TabId.SETUP }">{{ 'SERVICE.SETUP_DETAILS' | transloco }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="basis-full left-image">
    <div class="max-width-lg mr-144 mb-10">
      <div class="flex flex-row mt-20 h-100-percent mb-20" *ngIf="blueprintForm">
        <div [style.max-width.%]="26" *ngIf="showQuestionnaireSection" class="flex flex-col basis-full p-24 left-panel">
          <div class="flex flex-col">
            <div class="flex flex-row justify-center items-center"></div>
            <div class="flex flex-col">
              <div class="flex flex-row items-center p-8"
                  [ngClass]="[ currentStep === -1 ? 'questionnaire-steps' : 'unselected-text' ]">
                <div class="flex justify-center items-center mat-body-1 m-0 fw-600 cursor-pointer" (click)="goToStep(-1)">
                  <span [ngClass]="[ currentStep === -1 ? 'current-step-title' : 'unselected-text' ]">
                    {{ 'SERVICE.GENERAL' | transloco }}
                  </span>
                </div>
                <ng-container *ngIf="!blueprintForm.invalid && blueprintForm.touched;">
                  <mat-icon svgIcon="done" class="icon-sm mr-12 unselected-text"></mat-icon>
                </ng-container>
              </div>
              <div class="flex flex-row items-center p-8" *ngFor="let step of stepsArray"
                  [ngClass]="[ currentStep === step ? 'questionnaire-steps' : 'unselected-text' ]">
                <div class="flex justify-center items-center mat-body-1 m-0 fw-600 cursor-pointer" (click)="goToStep(step)">
                  <span [ngClass]="[ currentStep === step ? 'questionnaire-steps' : 'unselected-text' ]">
                    {{installationSpecificationForms[step]?.property.title}}
                  </span>
                </div>
                <ng-container *ngIf="!installationSpecificationForms[step]?.formGroup.invalid && installationSpecificationForms[step]?.formGroup.touched;">
                  <mat-icon svgIcon="done" class="icon-sm mr-12 unselected-text"></mat-icon>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col white-bg ml-10 w-100-percent h-100-percent p-24 order-position mb-50">
          <ng-container *ngIf="showQuestionnaireSection; else showSummarySection">
            <div id="service-setup-form">
              <ng-container *ngIf="currentStep === -1">
                <form [formGroup]="blueprintForm" class="flex flex-col mat-headline-6 m-0 mb-16">
                  <div class="flex flex-col form-field">
                    <div class="flex flex-row flex-wrap">
                      <label class="fw-700">{{ 'SERVICE.BLUEPRINT_NAME' | transloco | uppercase }}</label>
                      <mat-icon class="icon-sm ml-160 mt--16" [matTooltip]="'SERVICE.SERVICE_DEFINITION_NAME' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                      <span class="mandatory mt--22 ml-4 mat-body-2">*</span>
                    </div>         
                    <input appTitleCase class="blend-border mt-4"
                          [placeholder]="'SERVICE.ENTER' | transloco: { propertyName: ('SERVICE.BLUEPRINT_NAME_PLACEHOLDER' | transloco)}"
                          [formControl]="blueprintForm.get('name')" required [readonly]="blueprint && blueprint[0]?.name">
                    <app-error [control]="blueprintForm.get('name')"></app-error>
                    <!-- <ng-container *ngIf="!sandbox">
                      <div class="flex flex-row mt-20">
                        <label class="fw-700">{{ 'SERVICE.SYSGEN' | transloco | uppercase }}</label>
                        <mat-icon class="icon-sm ml-4" [matTooltip]="'SERVICE.SYSGEN_TOOLTIP' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                        <span class="mandatory mt--8 ml-4 mat-body-2">*</span>
                      </div>
                      <mat-slide-toggle color="primary" [disabled]="blueprint" [checked]="sysGenData" (change)="sysGen($event)"></mat-slide-toggle>
                    </ng-container> -->
                  </div>
                  <!-- <div class="flex flex-col form-field">
                    <label class="mb-4 fw-700">{{ 'SERVICE.REGION' | transloco | uppercase }}</label>
                    <mat-icon class="icon-sm ml-50 mt--20 " [matTooltip]="'SERVICE.REGION_NAME' | transloco"  matTooltipClass="right pb-0 tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                    <input class="blend-border mt-4"
                    [placeholder]="'SERVICE.ENTER' | transloco: { propertyName: ('SERVICE.REGION' | transloco)}"
                    [formControl]="blueprintForm.get('region')" required readonly>
                    <app-error [control]="blueprintForm.get('region')"></app-error>
                  </div> -->
                </form>
              </ng-container>
              <ng-container *ngIf="currentStep > -1 && stepsArray.length !== 0">
                <div class="mat-headline-5 mb-18 fw-600">
                  {{installationSpecificationForms[currentStep].property.title}}</div>
                <mat-divider class="mb-24 mt-8"></mat-divider>
                <app-dynamic-form *ngIf="!sandbox" [dynamicFormModel]="installationSpecificationForms[currentStep]">
                </app-dynamic-form>
                <app-sandbox-dynamic-form *ngIf="sandbox" [dynamicFormModel]="installationSpecificationForms[currentStep]">
                </app-sandbox-dynamic-form>
              </ng-container>
            </div>
          </ng-container>
          <ng-template #showSummarySection>
            <div>
              <div class="flex flex-col">
                <div class="flex flex-row">
                  <div class="basis-full heading fs-20 fw-700 mb-16">{{ 'SERVICE.GENERAL' | transloco }}</div>
                  <div class="flex justify-end cursor-pointer" (click)="goToStep(-1)">
                    <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
                    <div class="heading fs-20 fw-700">{{ 'BUTTONS.EDIT' | transloco }}</div>
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 mb-8">{{ 'SERVICE.SERVICE_NAME' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400  word-break-word">{{ this.blueprintForm.get('name').value }}</div>
                  </div>                
                </div>
              </div>
              <div *ngIf="includedCapabilities?.length > 0 || optionalCapabilities?.length > 0" class="flex flex-col">
                <div class="summary-divider mb-20 mt-20"></div>
                <div class="flex flex-row">
                  <div class="basis-full heading fs-20 fw-700 mb-24">
                    {{ 'CREATE_SERVICE.CAPABILITIES' | transloco }}</div>
                  <div class="flex justify-end cursor-pointer" (click)="goBack()">
                    <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
                    <div class="heading fs-20 fw-700">{{ 'BUTTONS.EDIT' | transloco }}</div>
                  </div>
                </div>
                <div class="flex flex-row w-90-percent justify-between">
                  <div *ngIf="includedCapabilities?.length > 0" class="flex flex-col">
                    <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.INCLUDED_CAPABILITIES' | transloco | uppercase }}</div>
                    <div class="flex flex-wrap">
                      <span *ngFor="let capability of includedCapabilities; let i = index">
                        <span class="mat-body-1">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                        <span *ngIf="i !== (includedCapabilities?.length - 1)" class="mr-4">,</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="optionalCapabilities?.length > 0" class="flex flex-col">
                    <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.OPTIONAL_CAPABILITIES' | transloco | uppercase }}</div>
                    <div class="flex flex-wrap">
                      <span *ngFor="let capability of optionalCapabilities; let i = index">
                        <span class="mat-body-1">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                        <span *ngIf="i !== (optionalCapabilities?.length - 1)" class="mr-4">,</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="additionalCapabilties?.length > 0" class="flex flex-col">
                    <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.ADDITIONAL_CAPABILITIES' | transloco | uppercase }}</div>
                    <div class="flex flex-wrap">
                      <span *ngFor="let capability of additionalCapabilties; let i = index">
                        <span class="mat-body-1">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                        <span *ngIf="i !== (additionalCapabilties?.length - 1)" class="mr-4">,</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col"
                  *ngFor="let installationSpecificationForm of installationSpecificationForms;let i = index">
                <mat-divider class="mb-16 mt-16"></mat-divider>
                <div class="flex flex-row">
                  <div class="basis-full heading fs-20 fw-700 mb-16">
                    {{ installationSpecificationForm.property.title }}</div>
                  <div class="flex justify-end cursor-pointer" (click)="goToStep(i)">
                    <mat-icon svgIcon="edit" class="icon-md mr-12"></mat-icon>
                    <div class="heading fs-20 fw-700">{{ 'BUTTONS.EDIT' | transloco }}</div>
                  </div>
                </div>
                <app-questionnaire-summary [dynamicFormModel]="installationSpecificationForm" [sandbox]="sandbox">
                </app-questionnaire-summary>
              </div>
            </div>
          </ng-template>
          <span class="flex-auto"></span>
        </div>
      </div>
    </div>
  </div>
  <span class="flex-auto"></span>
  <div class="summary-header max-width-lg mt-auto">
    <div class="flex flex-row justify-center items-center">
      <mat-icon svgIcon="arrow_back" class="icon-sm cursor-pointer mr-8" (click)="currentStep === -1 ? goBack() : goToStep(currentStep - 1)"></mat-icon>
      <div class="mat-subtitle-2 fw-700 mb-0 cursor-pointer" (click)="currentStep === -1 ? goBack() : goToStep(currentStep - 1)">
        {{ 'BUTTONS.PREVIOUS' | transloco }}
      </div>
      <button class="flex justify-center items-center blend-border cancel-btn ml-auto mr-18 p-16 pl-42 pr-42" (click)="goBack()">
        <mat-icon svgIcon="close" class="icon-sm cursor-pointer mr-8"></mat-icon>
        {{ 'BUTTONS.CANCEL' | transloco }}
      </button>
      <button
        *ngIf="showQuestionnaireSection || (stepsArray.length !== 0 && currentStep < stepsArray.length - 1); else showSetupButton"
        class="flex justify-center items-center mossgreen primary-fg p-16 pl-42 pr-42" type="button"
        (click)="goToStep(currentStep + 1)">{{ 'BUTTONS.CONTINUE' | transloco }}
        <mat-icon svgIcon="arrow_forward" class="icon-sm ml-8"></mat-icon>
      </button>
      <ng-template #showSetupButton>
        <div class="button-container">
          <div class="spinner-container" *ngIf="serviceLoader">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
          <button class="flex justify-center items-center items-center mossgreen primary-fg" type="button" [disabled]="serviceLoader" (click)="setup()">
            <span *ngIf="!blueprintId">{{sandbox ? ('SERVICE.CREATE_SANDBOX' | transloco) : ('SERVICE.CREATE_SERVICE_DEFINITION' | transloco) }}</span>
            <span *ngIf="blueprintId">{{ sandbox ? ('SERVICE.UPDATE_SANDBOX' | transloco) : ('SERVICE.UPDATE_SERVICE' | transloco) }}</span>
            <mat-icon svgIcon="arrow_forward" class="icon-sm ml-8"></mat-icon>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
